import React from 'react';

export interface IMessage {
  content: string;
  isOwner: boolean;
  createdAt: Date;
}

interface BaseMessageProps {
  message: string;
  at: Date;
  keyValue: string;
}

interface BaseMessageState {
  message: string;
  at: Date;
}

export default class BaseChatMessage extends React.Component<BaseMessageProps, BaseMessageState> {
  render() {
    return <div key={this.props.keyValue} />;
  }
}
